import React from 'react'
import axios from 'lib/axios'
import { generatePdfFromPages } from 'components/QuestionnaireRequestAutomated/processor/components/TasksSection/tasks/DownloadTask'

export default function Download({ questionnaireHashedId }) {
  const requestDownloadUrl = async () => {
    try {
      const response = await axios.post(`/questionnaire_requests/${questionnaireHashedId}/generate_download_url`)
      const { url } = response.data

      if (url) {
        window.open(url, '_blank')
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <span onClick={requestDownloadUrl} className="dome-cursor-pointer">
      <i className="fa-light fa-download fa-lg dome-color-dark-grey"></i>
    </span>
  )
}
